import styled from "styled-components";
import * as colors from "themes/colors";

export default styled.p`
  color: ${colors.telenorErrorTextColor};
  font-size: 12px;
`;
